import { Card, CardBody, Col } from "reactstrap";
import { P } from "../../../../AbstractElements";
import { Del, EmTeaxt, Highlight, InlineTextElements, InstText, Mark, SmallText, Stext, StrongText,  Utext } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { INLINE_DATA } from "../../../../Data/UiKit/Typography";

const InlinetextCart = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={InlineTextElements} span={INLINE_DATA}/>
        <CardBody>
          <div className="d-flex flex-column gap-2">
            <P className="mb-0">{Mark}<mark>{Highlight},</mark> Text.</P>
            <P className="mb-0"><del>{Del}</del></P>
            <P className="mb-0"><s>{Stext}</s></P>
            <P className="mb-0"><ins>{InstText}</ins></P>
            <P className="mb-0"><u>{Utext}</u></P>
            <P className="mb-0"><small>{SmallText}</small></P>
            <P className="mb-0"><strong>{StrongText}</strong></P>
            <P className="mb-0"><em>{EmTeaxt}</em></P>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default InlinetextCart;
